var _g, _defs, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSedimentationSubtitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 169.92,
    height: 434.559,
    baseProfile: "tiny",
    viewBox: "0 0 531 1358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    fontFamily: "MS Shell Dlg 2",
    fontSize: 32.5,
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillOpacity: 0,
    stroke: "none",
    d: "M-1.998-1.998h535.5V1359.73h-535.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    x2: 0,
    y1: 133.465,
    y2: 1220.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fde725",
    stopOpacity: 0.898
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#cfe11d",
    stopOpacity: 0.898
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.143,
    stopColor: "#9ed93a",
    stopOpacity: 0.898
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214,
    stopColor: "#71cf57",
    stopOpacity: 0.898
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#4ac26d",
    stopOpacity: 0.898
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#2db27d",
    stopOpacity: 0.898
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#1fa288",
    stopOpacity: 0.898
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#21908d",
    stopOpacity: 0.898
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#277f8e",
    stopOpacity: 0.898
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#2e6e8e",
    stopOpacity: 0.898
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#365c8d",
    stopOpacity: 0.898
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#3f4889",
    stopOpacity: 0.898
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    stopColor: "#46327f",
    stopOpacity: 0.898
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#481b6d",
    stopOpacity: 0.898
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#440154",
    stopOpacity: 0.898
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    fontFamily: "MS Shell Dlg 2",
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillOpacity: 0,
    stroke: "none",
    d: "M0-16.063h451.94v1242.54H0z",
    fontSize: 32.5
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 120,
    y: 88,
    fill: "#000",
    stroke: "none",
    fontSize: 42,
    transform: "translate(0 -16.063)scale(1.18)"
  }, "Profundidade"), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    strokeLinejoin: "miter",
    strokeMiterlimit: 2,
    d: "M23 133h94v1086H23z",
    fontSize: 32.5,
    transform: "matrix(.99907 0 0 .99907 0 -16.063)",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    stroke: "none",
    d: "M164.82 163.733h-17.708v-3.707h6.586v-24.343h-6.586v-3.317q3.733 0 5.5-1.061 1.77-1.061 1.989-4.013h3.78v32.734h6.44zm28.999-18.172q0 9.781-2.842 14.355t-8.768 4.573q-6 0-8.806-4.659-2.805-4.657-2.805-14.22 0-9.83 2.842-14.378 2.841-4.55 8.769-4.55 6 0 8.805 4.708 2.805 4.707 2.805 14.171m-6.244 11.074q.707-1.805 1-4.561.292-2.755.292-6.513 0-3.73-.292-6.488-.293-2.756-1.025-4.585-.731-1.854-2.012-2.817t-3.33-.964q-2.024 0-3.329.964-1.305.963-2.06 2.866-.733 1.853-1.001 4.683t-.268 6.39q0 3.805.231 6.366.232 2.561 1.013 4.586.707 1.879 2.012 2.89 1.305 1.013 3.403 1.013 2.024 0 3.329-.964t2.037-2.866m58.204 7.098v-15.757q0-1.877-.146-3.476-.146-1.597-.61-2.5-.488-.975-1.39-1.439-.903-.463-2.44-.463-1.415 0-3.036.866-1.623.865-3.354 2.5.024.415.061.988t.037 1.353v17.928h-4.586v-15.757q0-1.877-.146-3.476-.147-1.597-.61-2.5-.488-.975-1.39-1.439-.903-.463-2.44-.463-1.487 0-3.122.927t-3.17 2.366v20.342h-4.586v-27.245h4.586v3.024q1.805-1.805 3.573-2.792 1.768-.988 3.89-.988 2.415 0 4.28 1.097 1.867 1.098 2.842 3.61 2.074-2.317 4.05-3.512a8.14 8.14 0 0 1 4.292-1.195q1.755 0 3.196.549 1.438.548 2.512 1.768 1.097 1.245 1.695 3.098t.597 4.658v17.928zM166.674 1189.39H144.26v-5.098q2.415-2.293 4.56-4.39a97 97 0 0 0 4.196-4.366q4.146-4.562 5.659-7.305 1.512-2.745 1.512-5.671 0-1.513-.476-2.66-.476-1.144-1.304-1.902a5.7 5.7 0 0 0-1.976-1.097q-1.123-.366-2.464-.366-1.291 0-2.622.33-1.33.329-2.549.816-1.024.415-1.975 1-.951.586-1.537 1h-.268v-5.17q1.512-.757 4.207-1.476 2.695-.72 5.11-.72 5.074 0 7.952 2.696 2.878 2.694 2.878 7.305 0 2.121-.5 3.927a14.5 14.5 0 0 1-1.378 3.341 23 23 0 0 1-2.17 3.147 59 59 0 0 1-2.684 3.073 112 112 0 0 1-5.11 5.171 495 495 0 0 1-4.5 4.244h17.854zm26.56-11.562q0 2.635-.841 4.879-.842 2.244-2.354 3.878-1.536 1.659-3.817 2.61-2.28.951-5.11.951-2.61 0-5.134-.573t-4.379-1.5v-5.147h.342q.56.415 1.61.94 1.048.524 2.317.987 1.44.513 2.634.793 1.195.28 2.683.28 1.464 0 2.854-.524a5.8 5.8 0 0 0 2.39-1.695 7.5 7.5 0 0 0 1.378-2.512q.476-1.44.476-3.39 0-1.927-.524-3.172a5.15 5.15 0 0 0-1.525-2.049q-1.05-.927-2.573-1.304-1.525-.38-3.403-.379-1.975 0-3.976.305-2 .306-3.195.573v-18.708h19.928v4.269h-15.22v9.659a33 33 0 0 1 1.731-.147q.854-.048 1.562-.048 2.78 0 4.707.463 1.927.464 3.708 1.805a9.05 9.05 0 0 1 2.768 3.415q.963 2.049.963 5.341m52.546 11.562v-15.757q0-1.878-.146-3.476-.146-1.597-.61-2.5-.488-.975-1.39-1.439-.903-.463-2.44-.463-1.415 0-3.036.866-1.623.865-3.354 2.5.024.415.061.988t.037 1.353v17.928h-4.586v-15.757q0-1.878-.146-3.476-.147-1.597-.61-2.5-.488-.975-1.39-1.439-.903-.463-2.44-.463-1.487 0-3.122.927t-3.17 2.366v20.342h-4.586v-27.245h4.586v3.024q1.805-1.805 3.573-2.792 1.768-.988 3.89-.988 2.415 0 4.28 1.097 1.867 1.098 2.842 3.61 2.074-2.317 4.05-3.512a8.14 8.14 0 0 1 4.292-1.195q1.755 0 3.196.549 1.438.548 2.512 1.768 1.097 1.245 1.695 3.098.598 1.854.597 4.658v17.928z",
    fontSize: 32.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSedimentationSubtitle);
export default __webpack_public_path__ + "static/media/sedimentation_subtitle.e1cfe75a6b9053dfbce52a6531dd4c3d.svg";
export { ForwardRef as ReactComponent };